import { createI18nClient } from '@omilia/providers';

import translationFR from '../../locales/fr/translation.json';
import translationEN from '../../locales/en/translation.json';

export const languages = ['en', 'fr'] as const;
export type LanguagesType = typeof languages[number];
export const DEFAULT_LANGUAGE: LanguagesType = 'en';

const resources = {
  en: {
    translation: translationEN,
  },
  fr: {
    translation: translationFR,
  },
};

export const i18n = createI18nClient();
i18n.init({
  resources,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    escapeValue: false,
  },
});
